// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"305cd788","856":"bfbcc8e1"}[chunkId] + ".chunk.js";
};